// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.SearchBox {
    position: relative;
    display: flex;
    height: 2em;
    background-color: var(--input-bg-color);
    color: var(--text-color);
}

div.searchbox-field {
    flex: 1 1 auto;
}

button.searchbox-filter-button {
    flex: 0 0 auto;
    border-left-width: 0;
    padding: 0 0.25em 0 0.5em;
}

button.searchbox-filter-button > span.icon:last-child {
    font-size: 75%;
    margin-top: 1em;
}

div.searchbox-field > div.spinner {
    width: calc(2em - 2px);
    height: calc(2em - 2px);
}

div.searchbox-results {
    overflow-x: hidden;
}

div.searchbox-results-section-title {
    background-color: var(--list-section-bg-color);
    color: var(--list-section-text-color);
    font-weight: bold;
    padding: 0.5em;
    cursor: pointer;
    display: flex;
    align-items: center;
}

div.searchbox-results-section-title > span.icon {
    margin-right: 0.5em;
}

div.searchbox-result {
    padding: 0.25em 0.25em;
    display: flex;
    align-items: center;
}

div.searchbox-noresults {
    padding: 0.125em 0.5em;
    font-style: italic;
    color: var(--text-color-disabled);
}

div.searchbox-result-expandedinfo {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.searchbox-result > span.icon {
    flex: 0 0 1.5em;
}

.searchbox-result-thumbnail {
    flex: 0 0 1.5em;
    height: 1.5em;
}

span.searchbox-result-openicon {
    font-size: 75%;
    color: var(--text-color-disabled);
}

span.searchbox-result-label {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 0.25em;
    white-space: nowrap;
}

div.searchbox-result-abstract {
    padding: .5em;
    border-bottom: 1px solid var(--list-item-bg-color-hover);
    max-height: 10em;
    overflow-y: auto;
    font-size: 95%;
}

div.searchbox-more-results {
    color: grey;
    font-style: italic;
    padding: 0 0.5em;
    height: 1.75em;
    display: flex;
    align-items: center;
}

div.searchbox-filter-options {
    position: absolute;
    left: 0;
    top: 100%;
    min-width: 100%;
    background-color: var(--container-bg-color);
    border-left: 1px solid var(--border-color);
    border-right: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
}

div.searchbox-filter-options > table {
    width: 100%;
}

div.searchbox-filter-options > table td {
    padding: 0.25em;
    white-space: nowrap;
}

div.searchbox-filter-options > table td:last-child {
    width: 99%;
}

div.searchbox-filter-options > table td:last-child > div.combobox {
    width: 100%;
    height: 2em;
}

div.searchbox-filter-options-geometry > div.combobox {
    flex: 1 1 auto;
    height: 2em;
}
`, "",{"version":3,"sources":["webpack://./components/style/SearchBox.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,uCAAuC;IACvC,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;IACrC,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,wDAAwD;IACxD,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,eAAe;IACf,2CAA2C;IAC3C,0CAA0C;IAC1C,2CAA2C;IAC3C,4CAA4C;IAC5C,gDAAgD;AACpD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf","sourcesContent":["div.SearchBox {\n    position: relative;\n    display: flex;\n    height: 2em;\n    background-color: var(--input-bg-color);\n    color: var(--text-color);\n}\n\ndiv.searchbox-field {\n    flex: 1 1 auto;\n}\n\nbutton.searchbox-filter-button {\n    flex: 0 0 auto;\n    border-left-width: 0;\n    padding: 0 0.25em 0 0.5em;\n}\n\nbutton.searchbox-filter-button > span.icon:last-child {\n    font-size: 75%;\n    margin-top: 1em;\n}\n\ndiv.searchbox-field > div.spinner {\n    width: calc(2em - 2px);\n    height: calc(2em - 2px);\n}\n\ndiv.searchbox-results {\n    overflow-x: hidden;\n}\n\ndiv.searchbox-results-section-title {\n    background-color: var(--list-section-bg-color);\n    color: var(--list-section-text-color);\n    font-weight: bold;\n    padding: 0.5em;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\ndiv.searchbox-results-section-title > span.icon {\n    margin-right: 0.5em;\n}\n\ndiv.searchbox-result {\n    padding: 0.25em 0.25em;\n    display: flex;\n    align-items: center;\n}\n\ndiv.searchbox-noresults {\n    padding: 0.125em 0.5em;\n    font-style: italic;\n    color: var(--text-color-disabled);\n}\n\ndiv.searchbox-result-expandedinfo {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ndiv.searchbox-result > span.icon {\n    flex: 0 0 1.5em;\n}\n\n.searchbox-result-thumbnail {\n    flex: 0 0 1.5em;\n    height: 1.5em;\n}\n\nspan.searchbox-result-openicon {\n    font-size: 75%;\n    color: var(--text-color-disabled);\n}\n\nspan.searchbox-result-label {\n    flex: 1 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin: 0 0.25em;\n    white-space: nowrap;\n}\n\ndiv.searchbox-result-abstract {\n    padding: .5em;\n    border-bottom: 1px solid var(--list-item-bg-color-hover);\n    max-height: 10em;\n    overflow-y: auto;\n    font-size: 95%;\n}\n\ndiv.searchbox-more-results {\n    color: grey;\n    font-style: italic;\n    padding: 0 0.5em;\n    height: 1.75em;\n    display: flex;\n    align-items: center;\n}\n\ndiv.searchbox-filter-options {\n    position: absolute;\n    left: 0;\n    top: 100%;\n    min-width: 100%;\n    background-color: var(--container-bg-color);\n    border-left: 1px solid var(--border-color);\n    border-right: 1px solid var(--border-color);\n    border-bottom: 1px solid var(--border-color);\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n}\n\ndiv.searchbox-filter-options > table {\n    width: 100%;\n}\n\ndiv.searchbox-filter-options > table td {\n    padding: 0.25em;\n    white-space: nowrap;\n}\n\ndiv.searchbox-filter-options > table td:last-child {\n    width: 99%;\n}\n\ndiv.searchbox-filter-options > table td:last-child > div.combobox {\n    width: 100%;\n    height: 2em;\n}\n\ndiv.searchbox-filter-options-geometry > div.combobox {\n    flex: 1 1 auto;\n    height: 2em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
